import { Outlet } from "react-router-dom";
import "./design-theme.css";

export function DesignLayout() {
  return (
    <div className="design-scope">
      <Outlet />
    </div>
  );
}
